import React, { createContext, useContext, useEffect, useState } from "react";

const RecentlyViewedContext = createContext();

const RECENTLY_VIEWED_KEY = "recentlyViewed";

export const RecentlyViewedProvider = ({ children }) => {
  const [recentlyViewed, setRecentlyViewed] = useState([]);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const items = JSON.parse(localStorage.getItem(RECENTLY_VIEWED_KEY)) || [];
    setRecentlyViewed(items);
  }, []);

  const addRecentlyViewed = (product) => {
    if (typeof window === "undefined") return;

    let items = JSON.parse(localStorage.getItem(RECENTLY_VIEWED_KEY)) || [];

    items = items.filter((item) => item.id !== product.id);
    items.unshift(product);

    if (items.length > 2) items = items.slice(0, 2);

    localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(items));
    setRecentlyViewed(items); 
  };

  return (
    <RecentlyViewedContext.Provider value={{ recentlyViewed, addRecentlyViewed }}>
      {children}
    </RecentlyViewedContext.Provider>
  );
};

export const useRecentlyViewed = () => {
  const context = useContext(RecentlyViewedContext);
  if (!context) {
    throw new Error("useRecentlyViewed must be used within RecentlyViewedProvider");
  }
  return context;
};